'use client';

import { useFollowUser } from '@/hooks/useFollowUser/useFollowUser';
import { usePassportProfileUrl } from '@/hooks/usePassportProfileUrl/usePassportProfileUrl';
import { useRequireAuth } from '@/hooks/useRequireAuth/useRequireAuth';

interface UseUserInfoPopoverActionsResult {
  isLoading: boolean;
  onEditClick: (e: React.MouseEvent) => void;
  onFollowClick: (e: React.MouseEvent) => Promise<void>;
}

export function useUserInfoPopoverActions({
  userId,
  isCurrentUser,
  isFollowing,
  isFollowingStatusLoading,
}: {
  userId: string;
  isCurrentUser: boolean;
  isFollowing: boolean;
  isFollowingStatusLoading: boolean;
}): UseUserInfoPopoverActionsResult {
  const profileUrl = usePassportProfileUrl();
  const { requireAuth } = useRequireAuth();
  const { toggleFollow, isUserLoading } = useFollowUser();

  const isLoading = isUserLoading(userId) || isFollowingStatusLoading;

  const onEditClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (profileUrl) window.open(profileUrl, '_blank', 'noopener,noreferrer');
  };

  const onFollowClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (isCurrentUser) return;
    requireAuth(async () => {
      // useFollowUser handles all feedback (toast + state) and never throws.
      await toggleFollow(userId, isFollowing);
    });
  };

  return { isLoading, onEditClick, onFollowClick };
}
